import MySituation from '@/assets/conversations/MySituation.json';
import MyOptions from '@/assets/conversations/MyOptions.json';
import MyNetwork from '@/assets/conversations/MyNetwork.json';
import MyGoals from '@/assets/conversations/MyGoals.json';
import Evaluation from '@/assets/conversations/Evaluation.json';

const conversations = {
    MySituation,
    MyOptions,
    MyNetwork,
    MyGoals,
    Evaluation
};

export {
  conversations
}
